export default __webpack_public_path__ + "da33dba4302b73c8470fc6c90d3f2a2e.png";